export default __webpack_public_path__ + "static/media/oscer-character-randomise-case.e3026ac0.svg";